export default __webpack_public_path__ + "static/media/designed-for-everyone.4f5ea146.jpg";